import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { getCookie, get } from "@/api";

export default function useEventCheck() {
  const eventID = computed(() => getCookie("event"));
  const eventExpiry = ref(null);

  function redirectToHome() {
    window.location.href = `/safalta-app/?event=${eventID.value}`;
  }

  async function checkEventStatus() {
    if (!eventID.value) {
      redirectToHome();
    }
    if (!eventExpiry.value) {
      const result = await get(`event-status/${eventID.value}/`);
      eventExpiry.value = result.data.event_expiry;
    }
    if (eventExpiry.value) {
      if (eventExpiry.value < Math.round(Date.now() / 1000)) {
        redirectToHome();
      }
    } else {
      redirectToHome();
    }
  }

  onMounted(() => {
    checkEventStatus();
  });

  return { checkEventStatus };
}
